export const initialState = [
  // {
  //   name: "Slow Horses (Deluxe Edition)",
  //   author: "Mick Herron",
  //   thumbnail:
  //     "https://m.media-amazon.com/images/I/51Ga5GuElyL._SX331_BO1,204,203,200_.jpg",
  //   price: 14,
  //   rating: 3,
  //   featured: false,
  //   id: 1,
  // },
  // {
  //   name: "The Last Thing He Told Me: A Novel",
  //   author: "Laura Dave",
  //   thumbnail:
  //     "https://m.media-amazon.com/images/P/1501171348.01._SCLZZZZZZZ_SX500_.jpg",
  //   price: 13.99,
  //   rating: 4,
  //   featured: false,
  //   id: 2,
  // },
  // {
  //   name: "Eloquent JavaScript, 3rd Edition",
  //   author: "Marijn Haverbeke",
  //   thumbnail:
  //     "https://m.media-amazon.com/images/I/51InjRPaF7L._SX377_BO1,204,203,200_.jpg",
  //   price: 23.99,
  //   rating: 4,
  //   featured: true,
  //   id: 4,
  // },
];
